import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CustomCategoryTileComponent } from 'ish-shared/dias/components/category/custom-category-tile/custom-category-tile.component';

@Component({
  selector: 'custom-category-list',
  templateUrl: './custom-category-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CustomCategoryTileComponent],
})
export class CustomCategoryListComponent {
  readonly categories = input<string[]>(undefined);
}
